import 'dayjs/locale/uz-latn';
import 'dayjs/locale/ru';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useRouter } from 'next/router';

dayjs.extend(relativeTime);

export function TimeAgo(timestamp?: number): string {
  const { locale = 'uz' } = useRouter();

  if (!timestamp) return '';
  const ms = timestamp?.toString()?.length === 10 ? timestamp * 1000 : timestamp;

  return dayjs(ms)
    .locale(locale === 'uz' ? 'uz-latn' : 'ru')
    .fromNow();
}
